import { render, staticRenderFns } from "./Epicycloid.vue?vue&type=template&id=c8bf63e0&scoped=true&"
import script from "./Epicycloid.vue?vue&type=script&lang=js&"
export * from "./Epicycloid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8bf63e0",
  null
  
)

export default component.exports